import { isCancelledError } from '@tanstack/react-query';
import axios from 'axios';

/**
 * axios, AbortController ile iptal edilen istekleri bu `code` ile reddeder.
 * Call-site cancellation guard'ları (`err.code === ...`) bu sabiti karşılaştırmalı,
 * inline string tekrarı yerine — CLAUDE.md magic-string kuralı.
 *
 * Kept apart from lib/api so modules that load before the app (Sentry bootstrap) can use it
 * without pulling in the API client and the auth store.
 */
export const AXIOS_CANCELED_CODE = 'ERR_CANCELED';

export function isRequestCanceled(error: unknown): boolean {
  return axios.isCancel(error) || (error as { code?: string } | null)?.code === AXIOS_CANCELED_CODE;
}

/** Any intentional cancellation: an aborted axios request, a cancelled TanStack query, a DOM abort. */
export function isCanceledError(error: unknown): boolean {
  if (isCancelledError(error) || isRequestCanceled(error)) return true;
  return (error as { name?: unknown } | null)?.name === 'AbortError';
}
